import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, GraduationCapIcon } from 'lucide-react';
import { universities, slugify } from '../data/universityData';
import { useMetaTags } from '../hooks/useMetaTags';
export function PartnerCollegesPage() {
  useMetaTags({
    title: 'Partner Colleges | FindOnlineDegrees',
    description: 'Explore our partner colleges and request information directly from accredited schools offering programs that fit your goals.'
  });
  const partners = Object.values(universities);
  return <div className="bg-gray-100 min-h-screen" data-id="element-1192">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-1193">
        {/* Header */}
        <div className="text-center mb-10 max-w-3xl mx-auto" data-id="element-1194">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-[#e8594f]/10 text-[#e8594f] mb-3" data-id="element-1195">
            Partner Network
          </span>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" data-id="element-1196">
            Our Partner Colleges
          </h1>
          <p className="text-gray-600 leading-relaxed" data-id="element-1197">
            Browse the accredited colleges and universities we partner with.
            Click any school to request information directly from their
            admissions team.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1198">
          {partners.map(uni => {
          const href = `/universities/${uni.slug}`;
          return <Link key={uni.slug} to={href} className="group bg-white rounded-xl shadow-sm border border-gray-200 hover:shadow-md hover:border-gray-300 transition-all overflow-hidden flex flex-col" data-id="element-1199">
                {/* Branded color bar */}
                <div className="h-2 w-full" style={{
              backgroundColor: uni.primaryColor
            }} data-id="element-1200" />

                <div className="p-6 flex flex-col flex-grow" data-id="element-1201">
                  {/* Logo */}
                  <div className="h-16 mb-4 flex items-center" data-id="element-1202">
                    {uni.logoUrl ? <img src={uni.logoUrl} alt={uni.name} className="max-h-16 max-w-[200px] object-contain" data-id="element-1203" /> : <div className="flex items-center gap-2 text-gray-700" data-id="element-1204">
                        <GraduationCapIcon className="w-6 h-6" data-id="element-1205" />
                        <span className="font-bold" data-id="element-1206">{uni.shortName}</span>
                      </div>}
                  </div>

                  <h2 className="text-lg font-bold text-gray-900 mb-1 leading-tight" data-id="element-1207">
                    {uni.name}
                  </h2>
                  <p className="text-sm text-gray-500 mb-4" data-id="element-1208">{uni.tagline}</p>

                  {/* Quick facts */}
                  <div className="flex flex-wrap gap-2 mb-4" data-id="element-1209">
                    <span className="text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-700 font-medium" data-id="element-1210">
                      {uni.accreditation}
                    </span>
                    <span className="text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-700 font-medium" data-id="element-1211">
                      Founded {uni.founded}
                    </span>
                  </div>

                  {/* Degree levels */}
                  <div className="text-xs text-gray-500 mb-5" data-id="element-1212">
                    <span className="font-semibold text-gray-700" data-id="element-1213">
                      Degree Levels:
                    </span>{' '}
                    {uni.degreeLevels.join(', ')}
                  </div>

                  {/* Spacer + CTA */}
                  <div className="mt-auto pt-4 border-t border-gray-100 flex items-center justify-between" data-id="element-1214">
                    <span className="text-sm text-gray-500" data-id="element-1215">
                      {uni.programs.length} program
                      {uni.programs.length !== 1 ? 's' : ''}
                    </span>
                    <span className="inline-flex items-center gap-1.5 text-sm font-bold group-hover:gap-2.5 transition-all" style={{
                  color: uni.ctaColor
                }} data-id="element-1216">
                      Request Info
                      <ArrowRightIcon className="w-4 h-4" data-id="element-1217" />
                    </span>
                  </div>
                </div>
              </Link>;
        })}
        </div>

        {/* Disclosure */}
        <p className="text-xs text-gray-400 text-center mt-10 max-w-2xl mx-auto leading-relaxed" data-id="element-1218">
          FindOnlineDegrees.org is an advertising-supported site. Featured
          schools compensate us for leads. Compensation may impact placement,
          but does not influence our editorial content.
        </p>
      </div>
    </div>;
}